var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    fill: "#AEB2BE",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00021 0C3.67221 0 0.964844 2.70737 0.964844 6.03495C0.964844 10.8261 6.35263 15.6392 6.58211 15.8421C6.70211 15.9474 6.85116 16 7.00021 16C7.15516 16 7.31011 15.9432 7.43095 15.8299C7.65958 15.616 13.0356 10.5381 13.0356 6.03537C13.0356 2.70779 10.3274 0 7.00021 0ZM7.00021 8.91284C5.41074 8.91284 4.12274 7.624 4.12274 6.03579C4.12274 4.44758 5.41074 3.15874 7.00021 3.15874C8.58884 3.15874 9.87684 4.44716 9.87684 6.03579C9.87684 7.62442 8.58884 8.91284 7.00021 8.91284Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location.9cbeea0e59de65bef5e5cdac0aee1fd4.svg";